import type { CSSProperties, MouseEvent } from 'react';

// Row-action button styling for the Offers list, mirroring the Product Catalog
// look (32×32 ghost icon button + Material Symbols glyphs). Kept local to the
// offers module so we don't cross the feature import boundary.

/** Icon size (px) for edit / duplicate / delete on offer list rows */
export const OFFER_LIST_ACTION_ICON_PX = 18;

/** Shared 32×32 ghost icon button for offer list rows */
export const offerListActionButtonStyle: CSSProperties = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: 'none',
  background: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'var(--t3, #9CA3B8)',
  cursor: 'pointer',
  flexShrink: 0,
  padding: 0,
  transition: 'background 0.15s ease, color 0.15s ease',
};

export function offerListActionEnterDefault(e: MouseEvent<HTMLButtonElement>) {
  e.currentTarget.style.background = 'var(--hover, #F0F1F5)';
  e.currentTarget.style.color = 'var(--t1, #1A1D2E)';
}

export function offerListActionLeaveDefault(e: MouseEvent<HTMLButtonElement>) {
  e.currentTarget.style.background = 'transparent';
  e.currentTarget.style.color = 'var(--t3, #9CA3B8)';
}

export function offerListActionEnterDanger(e: MouseEvent<HTMLButtonElement>) {
  e.currentTarget.style.background = 'var(--red-soft, rgba(229,72,77,0.08))';
  e.currentTarget.style.color = 'var(--red, #E5484D)';
}

export function offerListActionLeaveDanger(e: MouseEvent<HTMLButtonElement>) {
  e.currentTarget.style.background = 'transparent';
  e.currentTarget.style.color = 'var(--t3, #9CA3B8)';
}
